<template>
  <div o-Container o-Container-App >
    <van-nav-bar :title="title" left-arrow @click-left="back"/>

    <div style="font-size:14px;font-size: 14px;font-family: PingFang SC;line-height: 30px;color: #0F0F0F;margin:25px;opacity: 1;">
      <p style="font-size: 23px;font-family: PingFang SC;font-weight: 400;line-height: 40px;">用户注册及合法使用</p>
      <p style="height: 2px;background: #000000;margin-top:19px"></p>
      <p style="font-family: PingFang SC;font-weight: 700;margin-top:20px">1.1 注册资格：用户应具有完全民事权利能力和行为能力，或虽不具有完全民事权利能力和行为能力，但经其法定代表人同意并由其法定代理人代理注册及应用GDSmrat服务。</p>
      <p style="margin-top:20px">1.2 用户一旦注册成功，将得到一个密码和账号，用户需妥善保管、安全使用。<span style="font-family: PingFang SC;font-weight: 700;">如果由于用户的过失导致其账号和密码遗失或失去控制，由此导致任何损失、责任将由该用户自行承担，与GDSmrat及其运营方无关。</span></p>
      <p style="margin-top:20px">1.3 如果GDSmrat发现使用者并非账号注册本人，GDSmrat有权停止继续服务。如用户发现其账号遭他人非法使用，应立刻通知GDSmrat。<span style="font-family: PingFang SC;font-weight: 700;">因黑客行为或用户违反本协议规定导致账号、密码遭他人非法使用的，由用户本人承担因此导致的损失和一切法律责任，GDSmrat不承担任何责任。</span></p>
      <p style="margin-top:20px">1.4 如果您认为您的密码或者访问您账号的其他方式已经泄漏，丢失或被盗，或者认为某一未授权个人正在或可能试图通过您的账号登录或使用本社区服务，<span style="font-family: PingFang SC;font-weight: 700;">请务必立即发送电子邮件到【gd_app_developer@gd-iot.com】通知。</span></p>
      <p style="margin-top:20px">1.5 GDSmrat账号（即GDSmrat用户ID）的所有权归GDSmrat，用户完成注册申请手续后，获得GDSmrat账号的使用权。用户应提供及时、详尽及准确的个人资料，并不断更新注册资料，符合及时、详尽准确的要求。所有原始键入的资料将引用为注册资料。<span style="font-family: PingFang SC;font-weight: 700;">如果因为注册信息不真实而引起的问题，并对问题发生所带来的后果，GDSmrat不负任何责任。</span></p>
      <p style="margin-top:20px">1.6 GDSmrat所使用和显示的商标、服务标识、商品名称和标志（统称为“商标”）归属于“法国智慧”所有，用户未被许可或授权使用这些“商标”。<span style="font-family: PingFang SC;font-weight: 700;">用户不得以任何目的复制、仿造或使用这些“商标”或与这些“商标”整体或部分相似的任何标志。</span></p>
      <p style="margin-top:20px">1.7 超链接。GDSmrat可能包含指向其他网站或资源的超链接。<span style="font-family: PingFang SC;font-weight: 700;">GDSmrat对通过这些链接而访问到的任何第三方资料或资源不承担任何责任。用户与第三方发生的任何交易均与GDSmrat无关。</span></p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "app_en_database_item", /* 这个name暂时不知道用啥用，根据官方文档说的是方便排错的 */
    data() {
      return {
        octopus: this.$parent.octopus,//传值
        title: '用户协议',//主题
      }
    },
    activated: function () {
    },
    methods: {
      //返回
      back: function(){
        window.history.go(-1);
      },
    },
    props: ["oData"]
  }
</script>



// WEBPACK FOOTER //
// src/components/APP/Main/Agreement/Page.vue